export interface Review {
  id: number;
  name: string;
  role: string;
  content: string;
  rating: number;
  avatar: string;
}

export const reviews: Review[] = [
  {
    id: 1,
    name: 'James Carter',
    role: 'Independent Reseller',
    content: 'The Mulebuy spreadsheet helped me organize everything clearly. I can now compare options much faster than before. The structured layout saves me hours every week.',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20man%20with%20short%20beard%20wearing%20olive%20green%20button%20down%20shirt%2C%20warm%20afternoon%20window%20light%2C%20relaxed%20confident%20expression%2C%20clean%20modern%20portrait%20photography%20style&width=120&height=120&seq=mulebuy-avatar-jc-v2&orientation=squarish',
  },
  {
    id: 2,
    name: 'Sarah Mitchell',
    role: 'Product Curator',
    content: 'I didn\'t realize how much time I was wasting until I switched to a spreadsheet-based workflow. The Mulebuy spreadsheet system completely transformed my sourcing process.',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20woman%20with%20curly%20hair%20wearing%20rust%20colored%20blouse%2C%20soft%20studio%20lighting%20with%20diffused%20quality%2C%20warm%20genuine%20smile%2C%20artistic%20portrait%20photography%20style&width=120&height=120&seq=mulebuy-avatar-sm-v2&orientation=squarish',
  },
  {
    id: 3,
    name: 'David Chen',
    role: 'Spreadsheet Enthusiast',
    content: 'The structured format made decision-making much easier and less stressful. Everything is laid out logically — no more second-guessing my choices.',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20asian%20man%20with%20glasses%20wearing%20navy%20polo%20shirt%2C%20clean%20white%20background%20studio%20lighting%2C%20intelligent%20approachable%20expression%2C%20crisp%20corporate%20portrait%20photography%20style&width=120&height=120&seq=mulebuy-avatar-dc-v2&orientation=squarish',
  },
  {
    id: 4,
    name: 'Emily Rodriguez',
    role: 'Inventory Manager',
    content: 'Great for tracking multiple items and keeping everything in one place. The category system is intuitive and makes bulk management a breeze.',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20latina%20woman%20with%20sleek%20hair%20wearing%20coral%20pink%20top%2C%20bright%20natural%20daylight%20from%20window%2C%20friendly%20approachable%20smile%2C%20warm%20lifestyle%20portrait%20photography%20style&width=120&height=120&seq=mulebuy-avatar-er-v2&orientation=squarish',
  },
  {
    id: 5,
    name: 'Michael Torres',
    role: 'Sourcing Coordinator',
    content: 'The Mulebuy spreadsheet system feels much more scalable than manual tracking. I went from managing 50 items to over 500 without any additional complexity.',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20man%20with%20salt%20pepper%20hair%20wearing%20charcoal%20henley%20shirt%2C%20dramatic%20side%20lighting%20with%20shadow%20depth%2C%20seasoned%20confident%20expression%2C%20editorial%20portrait%20photography%20style&width=120&height=120&seq=mulebuy-avatar-mt-v2&orientation=squarish',
  },
];